var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "role-edit" } },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.modal.title, "footer-hide": "" },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c(
            "IForm",
            {
              key: _vm.modal.visible,
              attrs: {
                model: _vm.edit,
                elem: _vm.roleElem,
                rules: _vm.roleRule,
                width: 520,
                "label-width": 80,
                button: "",
                "button-text": "取消",
              },
              on: {
                "on-submit": _vm.handleSubmit,
                "on-click": function ($event) {
                  _vm.modal.visible = false
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "extend" }, slot: "extend" },
                [
                  (_vm.userType >= 2 && _vm.userType <= 3) ||
                  (_vm.userType >= 2 &&
                    _vm.userType <= 3 &&
                    _vm.roleId == _vm.edit.parentId &&
                    _vm.edit.id) ||
                  (_vm.isAdmin &&
                    _vm.edit.level &&
                    _vm.edit.level == 3 &&
                    _vm.edit.id)
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 80,
                            label: "省份",
                            prop: "provinceCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "415px" },
                              attrs: {
                                multiple: _vm.userType == 2 || _vm.isAdmin,
                                disabled:
                                  _vm.isAdmin ||
                                  (_vm.edit.id != null &&
                                    _vm.edit.institutionId != null),
                              },
                              on: { "on-change": _vm.changeProvince },
                              model: {
                                value: _vm.areaController.provinceCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.areaController,
                                    "provinceCode",
                                    $$v
                                  )
                                },
                                expression: "areaController.provinceCode",
                              },
                            },
                            _vm._l(_vm.provinceList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.userType >= 3 && _vm.userType <= 4) ||
                  (_vm.userType >= 3 &&
                    _vm.userType <= 4 &&
                    _vm.roleId == _vm.edit.parentId &&
                    _vm.edit.id) ||
                  (_vm.isAdmin &&
                    _vm.edit.level &&
                    _vm.edit.level == 4 &&
                    _vm.edit.id)
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 80,
                            label: "城市",
                            prop: "cityCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "415px" },
                              attrs: {
                                multiple: _vm.userType == 3 || _vm.isAdmin,
                                disabled:
                                  _vm.isAdmin ||
                                  (_vm.edit.id != null &&
                                    _vm.edit.institutionId != null),
                              },
                              on: { "on-change": _vm.changeCity },
                              model: {
                                value: _vm.areaController.cityCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.areaController, "cityCode", $$v)
                                },
                                expression: "areaController.cityCode",
                              },
                            },
                            _vm._l(_vm.cityList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.userType >= 4 && _vm.userType <= 5) ||
                  (_vm.userType >= 4 &&
                    _vm.userType <= 5 &&
                    _vm.roleId == _vm.edit.parentId &&
                    _vm.edit.id) ||
                  (_vm.isAdmin &&
                    _vm.edit.level &&
                    _vm.edit.level == 5 &&
                    _vm.edit.id)
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 80,
                            label: "区",
                            prop: "areaCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "415px" },
                              attrs: {
                                multiple: _vm.userType == 4 || _vm.isAdmin,
                                disabled:
                                  _vm.isAdmin ||
                                  (_vm.edit.id != null &&
                                    _vm.edit.institutionId != null),
                              },
                              on: { "on-change": _vm.changeArea },
                              model: {
                                value: _vm.areaController.areaCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.areaController, "areaCode", $$v)
                                },
                                expression: "areaController.areaCode",
                              },
                            },
                            _vm._l(_vm.areaList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType == 5 ||
                  (_vm.userType == 5 &&
                    _vm.roleId == _vm.edit.parentId &&
                    _vm.edit.id) ||
                  (_vm.isAdmin &&
                    _vm.edit.level &&
                    _vm.edit.level == 6 &&
                    _vm.edit.id)
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 80,
                            label: "街道",
                            prop: "streetCode",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "415px" },
                              attrs: {
                                disabled:
                                  _vm.isAdmin ||
                                  (_vm.edit.id != null &&
                                    _vm.edit.institutionId != null),
                              },
                              on: { "on-change": _vm.changeStreet },
                              model: {
                                value: _vm.areaController.streetCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.areaController,
                                    "streetCode",
                                    $$v
                                  )
                                },
                                expression: "areaController.streetCode",
                              },
                            },
                            _vm._l(_vm.streetList, function (item) {
                              return _c(
                                "Option",
                                { key: item.code, attrs: { value: item.code } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userType == 5 ||
                  (_vm.userType == 6 && _vm.institutionList.length > 1) ||
                  (_vm.userType == 6 &&
                    _vm.roleId == _vm.edit.parentId &&
                    _vm.edit.id &&
                    _vm.institutionList.length > 1) ||
                  (_vm.isAdmin &&
                    _vm.edit.level &&
                    _vm.edit.level == 7 &&
                    _vm.edit.id)
                    ? _c(
                        "FormItem",
                        {
                          attrs: {
                            "label-width": 80,
                            label: "机构",
                            prop: "institutionId",
                          },
                        },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "415px" },
                              attrs: {
                                multiple: _vm.userType <= 6 || _vm.isAdmin,
                                disabled: _vm.isAdmin,
                              },
                              model: {
                                value: _vm.areaController.institutionIds,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.areaController,
                                    "institutionIds",
                                    $$v
                                  )
                                },
                                expression: "areaController.institutionIds",
                              },
                            },
                            _vm._l(_vm.institutionList, function (item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.name +
                                        (item.subordinate &&
                                        item.subordinate.length > 0
                                          ? "-" + item.subordinate
                                          : "")
                                    )
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "FormItem",
                    {
                      style: { "max-height": "350px", "overflow-y": "auto" },
                      attrs: {
                        "label-width": 80,
                        label: "权限",
                        prop: "menuIds",
                      },
                    },
                    [
                      _c("el-tree", {
                        ref: "menuTree",
                        attrs: {
                          data: _vm.menusData,
                          "show-checkbox": "",
                          "node-key": "id",
                          "default-checked-keys": [],
                          props: _vm.defaultProps,
                        },
                        on: { "check-change": _vm.menusCheck },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }